import { useState } from "react";
import Layout from "@/components/Layout";
import { PageHero } from "@/hooks/usePageContent";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "", order_number: "" });
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await http.post("/contact", { ...form, order_number: form.order_number || null });
      setSent(true);
      toast.success("Message sent. Mickey will be in touch.");
    } catch (err) {
      toast.error("Failed to send. Try again.");
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <PageHero slug="contact" />
      <section className="bg-black pt-24 pb-24">
        <div className="max-w-[760px] mx-auto px-6 md:px-12">
          <h1 className="text-grunge text-5xl text-[#F5F2EB] mb-2">SAY HELLO.</h1>
          <p className="font-body italic text-[#D4B07B] mb-10">Questions, gallery requests, or just a hello — drop a note.</p>

          {sent ? (
            <div className="border border-white/10 p-10 text-center">
              <h2 className="text-grunge text-3xl text-[#B8915A] mb-2">Message Received.</h2>
              <p className="font-body italic text-[#A3A3A3]">Mickey will be in touch soon.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
              <input data-testid="contact-name" required placeholder="Name" value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="stc-input"/>
              <input data-testid="contact-email" required type="email" placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="stc-input"/>
              <input placeholder="Order Number (optional)" value={form.order_number} onChange={e => setForm({...form, order_number: e.target.value})} className="stc-input"/>
              <textarea data-testid="contact-message" required rows={6} placeholder="Your message" value={form.message} onChange={e => setForm({...form, message: e.target.value})} className="stc-input font-body"/>
              <button data-testid="contact-submit" disabled={loading} className="btn-copper w-full justify-center">{loading ? "Sending…" : "Send Message"}</button>
            </form>
          )}
        </div>
      </section>
    </Layout>
  );
}
